import React from 'react';
import { Diary } from './Diary';

const Aletr = () => {
  return (
    <>
      <Diary>Deníček ve výstavbě</Diary>
    </>
  );
};
export default Aletr;
